<div class="main-container d-flex flex-column">
  <header>
    <app-header></app-header>
  </header>

  <!-- Loader spinner -->
  <div *ngIf="loadingService.loading$ | async" class="global-loader d-flex justify-content-center align-items-center" role="status" aria-live="polite" aria-label="Loading">
    <div class="dots-loader">
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>

  <main id="main-content" class="flex-fill" tabindex="-1">
    <router-outlet></router-outlet>
  </main>
  <footer *ngIf="!isTerminal">
    <app-footer></app-footer>
  </footer>

  <!-- Idle Timeout Modal -->
  <app-custom-modal
    #idleTimeoutModalRef
    [modalId]="'idleTimeoutModal'"
    [title]="'Inactive session'"
    [message]="idleMessage"
    [confirmButtonText]="'Yes, I am'"
    [cancelButtonText]="'Close this session'"
    [showConfirmOnly]="false"
    (onCloseModel)="handleModalClose($event)">
  </app-custom-modal>

  <!-- Payment Block Modal -->
  <app-payment-block-modal
    #paymentBlockModalRef
    [remainingSeconds]="paymentBlockRemainingSeconds"
    [outcome]="paymentBlockOutcome"
    [outcomeMessage]="paymentBlockOutcomeMessage"
    (goHome)="onPaymentBlockGoHome()"
    (acknowledge)="onPaymentBlockAcknowledge()">
  </app-payment-block-modal>
</div>
